import information from '@/views/mainContentCentral/information'
import basemenu from '@/views/mainContent/information/base'
import gaishu from '../views/mainContent/information/gaishu'
import xiangmu from '../views/mainContent/information/xiangmu'
import gaikuang from '../views/mainContent/information/gaikuang'

import special from '@/views/mainContentCentral/information/special'
import cut from '@/views/mainContentCentral/information/cut'
import synthesize from '@/views/mainContentCentral/information/synthesize'
import enclosure from '@/views/mainContentCentral/information/enclosure'
import download from '@/views/mainContentCentral/information/download'


import museumperson from '@/views/mainContentCentral/user'
import addmuseumperson from '@/views/mainContentCentral/user/listNew'

import specialist from '@/views/mainContentCentral/specialist'

import addspecialist from '@/views/mainContentCentral/specialist/listNew'

import country from '@/views/mainContentCentral/country'
import addcountry from '@/views/mainContentCentral/country/listNew'
import province from '@/views/mainContentCentral/province'
import addprovince from '@/views/mainContentCentral/province/listNew'
import museum from '@/views/mainContentCentral/statisticalQuery/museum'
import pfcx from '@/views/mainContentCentral/statisticalQuery/pfcx'
import progress from '@/views/mainContentCentral/processManagement'
import addaudit from '@/views/mainContentCentral/audit/addaudit'
import cutaudit from '@/views/mainContentCentral/audit/cutaudit'
import scoreadjust from '@/views/mainContentCentral/audit/scoreadjust'
import personinfo from '@/views/mainContentCentral/personinfo'
import otherfile from '@/views/mainContentCentral/information/otherfile'

import confirmCentral from '@/views/mainContentProvince/confirmProvince'
import libraryUser from '@/views/mainContentCentral/libraryUser'
import editlibraryUser from '@/views/mainContentCentral/libraryUser/listNew/index'
import score from "../views/mainContent/information/score";
export default {
  path: '/informationDeclarationCentral',
  component: information,
  exact: true,
  children: [
    { //基本信息
      path: '/informationDeclaration/museumbaseinfo/baseCentral',
      component: basemenu,
      exact: true,
    },
    { //博物馆活动项目
      path: '/informationDeclaration/museumbaseinfo/activityCentral',
      component: xiangmu,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/developCentral',
      component: gaikuang,
      exact: true,
    },
    { //发展概况
      path: '/informationDeclaration/museumbaseinfo/resourceCentral',
      component: gaishu,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/specialCentral',
      component: special,
      exact: true,
    },
    {
      path: '/informationDeclaration/enclosureCentral',
      component: enclosure,
      exact: true,
    },
    {
      path: '/informationDeclaration/downloadCentral',
      component: download,
      exact: true,
    },
    {
      path: '/expert/museumgroupCentral',
      component: museumperson,
      exact: true,
    },
    {
      path: '/expert/museumgroupProvince',
      component: museumperson,
      exact: true,
    },
    {
      path: '/expert/addmuseumpersonCentral',
      component: addmuseumperson,
      exact: true,
    },
    {
      path: '/expert/specialistCentral',
      component: specialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/warningCentral',
      component: cut,
      exact: true,
    },
    {
      path: '/expert/addspecialistCentral',
      component: addspecialist,
      exact: true,
    },
    {
      path: '/person/userCentral',
      component: country,
      exact: true,
    },
    {
      path: '/person/addcountryCentral',
      component: addcountry,
      exact: true,
    },
    {
      path: '/person/provinceCentral',
      component: province,
      exact: true,
    },
    {
      path: '/informationDeclaration/addprovinceCentral',
      component: addprovince,
      exact: true,
    },
    {
      path: '/query/museumCentral',
      component: museum,
      exact: true,
    },
    {
      path: '/query/museumProvince',
      component: museum,
      exact: true,
    },
    {
      path: '/query/scoreCentral',
      component: pfcx,
      exact: true,
    },
    {
      path: '/progressCentral',
      component: progress,
      exact: true,
    },
    {
      path: '/confirm/addauditCentral',
      component: addaudit,
      exact: true,
    },
    {
      path: '/confirm/cutauditCentral',
      component: cutaudit,
      exact: true,
    },
    {
      path: '/confirm/scoreadjustCentral',
      component: scoreadjust,
      exact: true,
    },
    {
      path: '/personinfo',
      component: personinfo,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/otherfileCentral',
      component: otherfile,
      exact: true,
    },
    {
      path: '/confirmCentral',
      component: confirmCentral,
      exact: true,
    },
    {
      path: '/person/museumadminCentral',
      component: libraryUser,
      exact: true,
    },
    {
      path: '/person/museumadminProvince',
      component: libraryUser,
      exact: true,
    },
    {
      path: '/libraryuser/addcountryCentral',
      component: editlibraryUser,
      exact: true,
    },
    { //评分详情
      path: '/informationDeclaration/scoredetailCentral',
      component: score,
      exact: true,
    },
    { //评分详情
      path: '/informationDeclaration/proposalCentral',
      component: synthesize,
      exact: true,
    },
    { //评分详情
      path: '/informationDeclaration/proposalProvince',
      component: synthesize,
      exact: true,
    },
  ]
}
